<template>
  <div class="help-area">
    <ul class="help__list">
      <li class="help__item sp-none">
        <router-link :to="$route.path === '/' ? '#concept' : '/#concept'" @click="onTapCloseButton"> コンセプト
        </router-link>
      </li>
      <li class="help__item sp-none">
        <router-link :to="$route.path === '/' ? '#news' : '/#news'" @click="onTapCloseButton"> お知らせ </router-link>
      </li>
      <li class="help__item sp-none">
        <router-link :to="$route.path === '/' ? '#lesson' : '/#lesson'" @click="onTapCloseButton"> スケジュール </router-link>
      </li>
      <li class="help__item sp-none">
        <router-link :to="$route.path === '/' ? '#menu' : '/#menu'" @click="onTapCloseButton"> クラス紹介 </router-link>
      </li>
      <li class="help__item sp-none">
        <router-link :to="$route.path === '/' ? '#price' : '/#price'" @click="onTapCloseButton"> 料金 </router-link>
      </li>
      <li class="help__item sp-none">
        <router-link :to="$route.path === '/' ? '#flow' : '/#flow'" @click="onTapCloseButton"> 入会の流れ </router-link>
      </li>
      <li class="help__item sp-none">
        <router-link :to="$route.path === '/' ? '#qa' : '/#qa'" @click="onTapCloseButton"> よくある質問 </router-link>
      </li>
      <li class="help__item sp-none">
        <router-link :to="$route.path === '/' ? '#staff' : '/#staff'" @click="onTapCloseButton"> スタッフ紹介</router-link>
      </li>
      <li class="help__item sp-none">
        <router-link to="/Facilittes" @click="onTapCloseButton">施設紹介</router-link>
      </li>
      <li class="help__item sp-none">
        <router-link :to="$route.path === '/' ? '#info' : '/#info'" @click="onTapCloseButton"> ジム案内</router-link>
      </li>
      <li class="help__item sp-none">
        <router-link :to="$route.path === '/' ? '#access' : '/#access'" @click="onTapCloseButton"> アクセス</router-link>
      </li>
      <li class="help__item sp-none">
        <router-link to="/Contact" @click="onTapCloseButton"> お問い合わせ </router-link>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useApplicationStore } from '@/store/modules/applicationModule'

export default defineComponent({
  components: {},
  setup() {
    const ApplicationStore = useApplicationStore()
    const shouldShowHelpPopup = computed(() => ApplicationStore.getShouldShowHelpPopup)

    const onTapCloseButton = () => {
      ApplicationStore.UPD_HELP_POPUP(false)
    }

    return {
      onTapCloseButton,
      shouldShowHelpPopup,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '~@/assets/css/colors';

// override PopupScroll（accountNoteHosp only）
:deep(.popup__box) {
  width: 100%;
  height: 100%;
  padding: 22px 0;
}

:deep(.popup__title) {
  padding: 0 30px 0 40px;
}
:deep(.popup__title::before) {
  left: 30px;
}

:deep(.iscroll-wrapper) {
  padding: 0 30px;
}

// override Tabs
:deep(.tabs-area) {
  pointer-events: none;
  width: 100%;
  margin-top: 5px;
}

:deep(.tab) {
  width: 100%;
  padding: 5px 0 5px 12px;
}

:deep(.tab__text) {
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1;
  padding-right: 12px;
  border-right: 1px solid rgba($color: $gray1, $alpha: 0.1);
}

.help {
  &-area {
    position: fixed;
    top: 0;
    right: 0;
    width: 70%;
    height: 100%;
    padding-top: 76px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    z-index: 999;
    font-family: 'Noto Serif JP', serif;
    background-color: #fff;
    box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.2);
  }
  &__ {
    &list {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
    }
    &item {
      display: flex;
      justify-content: center;
      padding: 10px 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      color: #fff;

      & a {
        color: #333;
        font-size: 1.6rem;
      }

      &:last-of-type {
        border-bottom: none;
        background-color: $sub;
        padding: 10px;

        a {
          color: #fff;
        }
      }
    }

    &thumbup-button {
      margin: 5px 0;
    }
  }
  &- {
    &icon {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      max-width: 125px;
      width: 100%;

      &-text {
        margin-top: 13px;
        font-size: 1.1rem;
        line-height: 1;
      }
    }

    &description {
      width: 100%;
      display: flex;
      align-items: center;

      &::before {
        content: '';
        border-top: 1px dashed rgba(0, 0, 0, 0.5);
        max-width: 20px;
        width: 100%;
        margin-right: 20px;
        margin-left: 3px;
      }

      &-text {
        font-size: 1.4rem;
      }
    }
  }
}

.img-wrap {
  text-align: center;

  & img {
    max-height: calc(100vh - 100px);
    height: 90%;
    max-width: 550px;
  }
}

.fade-right {
  transform: translateX(-100%);
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    transform: translateX(0);
    opacity: 1;
  }
}

@media screen and (max-width: 768px) {
  .img-wrap {
    text-align: center;

    & img {
      max-width: 300px;
      width: 100%;
    }
  }
}

@media screen and (max-width: 500px) {
  .img-wrap {
    text-align: center;

    & img {
      max-width: 150px;
      width: 100%;
    }
  }
}

@media screen and (max-width: 400px) {
  .img-wrap {
    display: none;
    text-align: center;

    & img {
      max-width: 150px;
      width: 100%;
    }
  }
}
</style>
